import { render, staticRenderFns } from "./SendConfigModal.vue?vue&type=template&id=2c0f9385&scoped=true&"
import script from "./SendConfigModal.vue?vue&type=script&lang=js&"
export * from "./SendConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./SendConfigModal.vue?vue&type=style&index=0&id=2c0f9385&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f9385",
  null
  
)

export default component.exports